<template>
    <div>
        <!--Welcome Message-->
        <div class="row hello text-center">
            <div class="col-md-12">
                <h3>
                    <p>Hello {{displayName}}, welcome to PreRec</p>

                    <p>Please read the tips below before joining the session...</p>
                </h3>

                <button class="btn btn-lg btn-primary" @click="joinSession">Join Session</button>
            </div>
        </div>

        <!--Tip - device-->
        <div class="row mt-5 p-3">
            <div class="col-md-5 pic">
                <img
                    width=80px
                    height=80px
                    src="@/assets/images/bluetooth-disabled-button.svg"
                    class="img-fluid float-right"
                    alt="No Bluetooth"
                />
            </div>
            <div class="col-md-6 pt-2 text">
                <p>
                    Please <b>DO NOT</b> use a Bluetooth microphone/headset as they often do not record.
                </p>
            </div>
        </div>

        <!--Tip - device-->
        <div class="row p-3">
            <div class="col-md-5 pic">
                <img
                    src="@/assets/images/Earphone_100h.png"
                    class="img-fluid float-right"
                    alt="Headphones"
                />
            </div>
            <div class="col-md-6 pt-2 text">
                <p>
                    Please ensure your headphones are plugged in.
                    <br />This will avoid echo and feedback, and will make the recording sound much better.
                </p>
            </div>
        </div>

        <!--Tip - Location-->
        <div class="row p-3">
            <div class="col-md-5 pic">
                <img src="@/assets/images/Room_100h.png" class="img-fluid float-right" alt="A Room" />
            </div>
            <div class="col-md-6 text">
                <p>
                    Where are you?
                    <br />If possible choose a quiet location with soft furnishings rather than a tiled room.
                </p>
            </div>
        </div>
    </div>   
</template>

<script>
export default {
    props: {
        displayName: {
            type: String,
            required: true
        }
    },

    methods: {
        joinSession() {
            this.$emit('joinSession');
        }
    }
}
</script>